import { Country } from '../country.js';

export enum InvoiceVat {
  Vat_0 = '0%',
  Vat_1 = '1%',
  Vat_2 = '2%',
  Vat_3 = '3%',
  Vat_4 = '4%',
  Vat_5 = '5%',
  Vat_6 = '6%',
  Vat_7 = '7%',
  Vat_8 = '8%',
  Vat_9 = '9%',
  Vat_10 = '10%',
  Vat_11 = '11%',
  Vat_12 = '12%',
  Vat_13 = '13%',
  Vat_14 = '14%',
  Vat_15 = '15%',
  Vat_16 = '16%',
  Vat_17 = '17%',
  Vat_18 = '18%',
  Vat_19 = '19%',
  Vat_20 = '20%',
  Vat_21 = '21%',
  Vat_22 = '22%',
  Vat_23 = '23%',
  Vat_24 = '24%',
  Vat_25 = '25%',
  Vat_26 = '26%',
  Vat_27 = '27%',
  Vat_Aam = 'AAM',
  Vat_Am = 'AM',
  Vat_Eu = 'EU',
  Vat_Euk = 'EUK',
  Vat_FAfa = 'F.AFA',
  Vat_Fad = 'FAD',
  Vat_KAfa = 'K.AFA',
  Vat_Maa = 'MAA',
  Vat_Tam = 'TAM',
  Vat_Kk = 'ÁKK',
  Vat_Thk = 'ÁTHK'
}

const valueOfInvoiceVat: Map<InvoiceVat, number> = new Map<InvoiceVat, number>([
  [InvoiceVat.Vat_0, 0],
  [InvoiceVat.Vat_1, 1],
  [InvoiceVat.Vat_2, 2],
  [InvoiceVat.Vat_3, 3],
  [InvoiceVat.Vat_4, 4],
  [InvoiceVat.Vat_5, 5],
  [InvoiceVat.Vat_6, 6],
  [InvoiceVat.Vat_7, 7],
  [InvoiceVat.Vat_8, 8],
  [InvoiceVat.Vat_9, 9],
  [InvoiceVat.Vat_10, 10],
  [InvoiceVat.Vat_11, 11],
  [InvoiceVat.Vat_12, 12],
  [InvoiceVat.Vat_13, 13],
  [InvoiceVat.Vat_14, 14],
  [InvoiceVat.Vat_15, 15],
  [InvoiceVat.Vat_16, 16],
  [InvoiceVat.Vat_17, 17],
  [InvoiceVat.Vat_18, 18],
  [InvoiceVat.Vat_19, 19],
  [InvoiceVat.Vat_20, 20],
  [InvoiceVat.Vat_21, 21],
  [InvoiceVat.Vat_22, 22],
  [InvoiceVat.Vat_23, 23],
  [InvoiceVat.Vat_24, 24],
  [InvoiceVat.Vat_25, 25],
  [InvoiceVat.Vat_26, 26],
  [InvoiceVat.Vat_27, 27],
]);

const invoiceVatOfValue: Map<number, InvoiceVat> = new Map<number, InvoiceVat>([
  [0, InvoiceVat.Vat_0],
  [1, InvoiceVat.Vat_1],
  [2, InvoiceVat.Vat_2],
  [3, InvoiceVat.Vat_3],
  [4, InvoiceVat.Vat_4],
  [5, InvoiceVat.Vat_5],
  [6, InvoiceVat.Vat_6],
  [7, InvoiceVat.Vat_7],
  [8, InvoiceVat.Vat_8],
  [9, InvoiceVat.Vat_9],
  [10, InvoiceVat.Vat_10],
  [11, InvoiceVat.Vat_11],
  [12, InvoiceVat.Vat_12],
  [13, InvoiceVat.Vat_13],
  [14, InvoiceVat.Vat_14],
  [15, InvoiceVat.Vat_15],
  [16, InvoiceVat.Vat_16],
  [17, InvoiceVat.Vat_17],
  [18, InvoiceVat.Vat_18],
  [19, InvoiceVat.Vat_19],
  [20, InvoiceVat.Vat_20],
  [21, InvoiceVat.Vat_21],
  [22, InvoiceVat.Vat_22],
  [23, InvoiceVat.Vat_23],
  [24, InvoiceVat.Vat_24],
  [25, InvoiceVat.Vat_25],
  [26, InvoiceVat.Vat_26],
  [27, InvoiceVat.Vat_27],
]);

/**
 * @param {Country} country The country for which to get the VAT rate.
 * @return {InvoiceVat} The VAT rate associated with the given country.
 * @deprecated VAT rates must not be inferred from country alone; use business, invoicing, and product rules.
 */
export function getInvoiceVatOfCountry(country: Country): InvoiceVat {
  switch(country) {
    case Country.Austria:
      return InvoiceVat.Vat_20;
    case Country.Hungary:
      return InvoiceVat.Vat_27;
    case Country.Romania:
      return InvoiceVat.Vat_19;
    case Country.Slovakia:
      return InvoiceVat.Vat_23;
    case Country.Slovenia:
      return InvoiceVat.Vat_22;
    default:
      return InvoiceVat.Vat_0;
  }
}

export function getInvoiceVatFromValue(vat: number): InvoiceVat | undefined {
  return invoiceVatOfValue.get(vat);
}

export function getValueOfInvoiceVat(vat: InvoiceVat): number | undefined {
  return valueOfInvoiceVat.get(vat);
}
